import { render, staticRenderFns } from "./zyRanking.vue?vue&type=template&id=42c9e059&scoped=true&"
import script from "./zyRanking.vue?vue&type=script&lang=js&"
export * from "./zyRanking.vue?vue&type=script&lang=js&"
import style0 from "./zyRanking.vue?vue&type=style&index=0&id=42c9e059&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9e059",
  null
  
)

export default component.exports